import { atom } from 'jotai';

import type { IVirtualAccountInfo } from '../../types';

export const virtualAccountInfoStore = atom<IVirtualAccountInfo | undefined>(
  undefined,
);

export const virtualAccountExpiresStore = atom<string>('');

export const invoiceIdStore = atom<string | undefined>(undefined);
